<template>
  <div v-if="items.length" class="collapse-methods-list">
    <div class="collapse-methods-list__content">
      <contact-method :item="contact_methods[0]" class="collapse-methods-list__item" />

      <b-collapse
        v-if="items.length > 1"
        id="collapse"
        v-model="is_collapse"
        class="collapse-wrapper"
      >
        <contact-method
          v-for="method in collapse_items"
          :key="method.id"
          :item="method"
          class="collapse-methods-list__item"
        />
      </b-collapse>
    </div>

    <div v-if="items.length > 1" class="collapse-methods-list__control">
      <icon
        class="collapse-methods-list__control-icon"
        :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
        @click="is_collapse = !is_collapse"
      />
    </div>
  </div>
</template>

<script>
  import ContactMethod from '../item';
  import { ContactMethodFormatter } from '@pbx/services/formatter/ContactMethod';

  export default {
    components: { ContactMethod },
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      is_collapse: false
    }),

    computed: {
      contact_methods: function() {
        return ContactMethodFormatter.formatItems(this.items);
      },

      collapse_items: function() {
        return this.contact_methods.filter((item, index) => index > 0);
      }
    }
  };
</script>

<style lang="scss">
  .collapse-methods-list {
    display: flex;

    &__content {
      flex: auto;
      padding-right: 30px;
    }

    &__control {
      margin-left: -15px;
      display: flex;
      align-items: center;
    }

    &__control-icon {
      font-size: 18px;

      &:hover {
        cursor: pointer;
      }
    }

    &__item {
      padding: 5px 0;
    }
  }
</style>
